import { render } from "./EditLocation.vue?vue&type=template&id=6cf2255f"
import script from "./EditLocation.vue?vue&type=script&lang=js"
export * from "./EditLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Admin/Tenants/EditLocation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cf2255f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cf2255f', __exports__)) {
    api.reload('6cf2255f', __exports__)
  }
  
  module.hot.accept("./EditLocation.vue?vue&type=template&id=6cf2255f", () => {
    api.rerender('6cf2255f', render)
  })

}


export default __exports__